import Header from './components/Header';
import Hero from './components/Hero';
import TopicTags from './components/TopicTags';
import Ranking from './components/Ranking';
import TopicIndex from './components/TopicIndex';
import MediaCards from './components/MediaCards';
import Comments from './components/Comments';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import InfoCards from './components/InfoCards';
import Carousel from './components/Carousel';
import AppEntry from './components/AppEntry';
import About from './components/About';
import Contact from './components/Contact';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicTags />
        <Ranking />
        <TopicIndex />
        <MediaCards />
        <Comments />
        <Updates />
        <FAQ />
        <InfoCards />
        <Carousel />
        <AppEntry />
        <About />
        <Contact />
        <Features />
      </main>
      <Footer />
    </>
  );
}